// extracted by mini-css-extract-plugin
export var button = "_iz-0";